import script from "./DarkModeToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&setup=true&lang=js"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=30c61eb7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c61eb7"]])

export default __exports__